import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text'
import SwitchToggle from 'core-system/SwitchToggle'
import Chip from 'core-system/Chip'
import SegmentService from 'redux/config/services/SegmentService'

const Container = styled.div`
  background-color: ${(props) => props.theme.palette.white};
  border: 1px solid ${(props) => props.theme.palette.secondary.purple300};
  border-radius: 0.9375rem;
  padding: 1.5rem 2rem;
`

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

interface ProgramEditSubSectionProps {
  children?: React.ReactNode
  title: string
  description: string
  canEdit?: boolean
  active?: boolean
  handleToggle: (type: string) => void
  type: string
}

const ProgramEditSubSection = ({
  children,
  title,
  description,
  canEdit,
  active,
  handleToggle,
  type,
}: ProgramEditSubSectionProps) => {
  return (
    <Container>
      <HeaderContainer>
        <Text variant='h4'>{title}</Text>
        {canEdit ? (
          <SwitchToggle
            active={active}
            onClick={() => {
              handleToggle(type)
              SegmentService.track('program-option-toggle', {
                [type]: !active,
              })
            }}
            data-cy={`${type}-switch`}
          />
        ) : (
          <Chip variant={active ? 'green' : 'grey'}>
            {active ? 'Active' : 'Disabled'}
          </Chip>
        )}
      </HeaderContainer>
      <Text variant='body1' margin={children ? '1.5rem 0' : '1.5rem 0 0 0'}>
        {description}
      </Text>
      {active && <div>{children}</div>}
    </Container>
  )
}

export default React.memo(ProgramEditSubSection)
